module.exports = __webpack_public_path__ + "img/TRS.0a950e7d.png";